/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

export interface CopilotChatResponse {
    query_key: string;
    refined_query: string;
    response: string;
    session_id: string;
    response_time: number;
    debug_info: boolean | null
}

const copilotChat = async (
  queryData: string,
  sessionId: string | null = null
): Promise<CopilotChatResponse | undefined> => {
  const token = useUserStore.getState().userToken;
  const userId = useUserStore.getState().userDetails._id;
  const companyId = useCompanyStore.getState().companyId;
  
  try {
    const copilotChatBody = {
      user_id: userId,
      company_id: companyId,
      query: queryData,
      session_id: sessionId,
      debug_info: false
    };
    const response = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.copilotChat}`,
      params: {},
      headers: {
         Authorization: `Bearer ${token}`
      },
      data: copilotChatBody ?? {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default copilotChat;
